// extracted by mini-css-extract-plugin
export var avatarContainer = "_97-0";
export var avatarTypingWave = "_97-i";
export var gray = "_97-f";
export var green = "_97-c";
export var icon = "_97-9";
export var image = "_97-1";
export var lg = "_97-6";
export var md = "_97-5";
export var presenceDot = "_97-b";
export var red = "_97-d";
export var sm = "_97-4";
export var status = "_97-a";
export var typingDot = "_97-h";
export var typingPill = "_97-g";
export var xl = "_97-7";
export var xs = "_97-3";
export var xxl = "_97-8";
export var xxs = "_97-2";
export var yellow = "_97-e";